
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/mapka-tras",
      function () {
        return require("private-next-pages/[region]/[resort]/mapka-tras.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/mapka-tras"])
      });
    }
  